import { gql } from 'graphql-request';

export default gql`
  query nextUserExtension($data: JSON) {
    nextUserExtension(data: $data) {
      success
      message
      data
    }
  }
`;
